import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/equipment/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/equipment/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/equipment/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/equipment/submit', params, options);

export const update = (params, options) => request.post('/api/equipment/update', params, options);

export const getEquipmentTree = (id) => {
  return request({
    url: 'api/equipment/tree',
    method: 'get',
    params: {
      id,
    },
  });
};
